@if (isMultiEntryByEnter) {
  <ap-field [title]="filterColumn().label" [required]="false" [error]="false">
    <div class="d-flex flex-wrap gap-2 mb-2 mt-2">
      @for (entry of selectedEntries; track $index; let i = $index) {
        <span
          class="badge d-inline-flex align-items-center gap-1 fw-normal text-bg-secondary">
          {{ entry }}
          <button
            type="button"
            class="btn-close btn-close-white"
            style="font-size: 0.5em"
            (click)="removeEntry(i)"
            aria-label="Remove rate"></button>
        </span>
      }
    </div>

    <input
      appkit-field
      [value]="pendingEntry"
      placeholder="Type rate and press Enter"
      (input)="pendingEntry = $any($event.target).value"
      (keydown.enter)="addEntryByEnter($event)"
      (blur)="blurHandler()" />
  </ap-field>
} @else {
  <gstar-textfield
    [label]="filterColumn().label"
    [delay]="400"
    [showSuggestion]="false"
    [(ngModel)]="value"
    (blurField)="blurHandler()"
    (changeField)="changeFieldHandler($event)" />
}
